<template>
  <section class="item-container">
    <div class="container">
      <div class="price-container">
        <h5 v-if="option.price !== undefined" class="name">
          {{ option.name }} ({{ formatMoney(option.price) }})
        </h5>
        <h5 v-else class="name">
          {{ option.name }}
        </h5>
      </div>

      <BandAid
        :quantity="quantitySelected"
        @plusQuantity="innerPlusQuantity()"
        @lessQuantity="innerLessQuantity()"
      />
    </div>
  </section>
</template>

<script>
import BandAid from "./BandAid";

export default {
  name: "AdditionalItemBandAid",
  props: {
    option: {
      type: Object,
      default: () => {
        return {};
      },
    },
    quantitySelected: {
      type: Number,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    formatMoney(price) {
      return new Intl.NumberFormat("es-ar", {
        style: "currency",
        currency: "ARS",
      }).format(price);
    },
    innerPlusQuantity() {
      this.$emit("innerPlusQuantity");
    },
    innerLessQuantity() {
      this.$emit("innerLessQuantity");
    },
  },
  data() {
    return {};
  },
  components: {
    BandAid,
  },
};
</script>

<style scoped>
.container {
  display: inline-flex;
  padding: 0em !important;
}
.item-container {
  padding: 0.5em;
  background: white;
  border-bottom: 0.5px solid #ccc;
  width: 99%;
  display: inline-block;
  -webkit-transition: box-shadow 0.2s ease-in-out;
  transition: box-shadow 0.2s ease-in-out;
}
.image-container {
  align-self: center;
}
.item-content {
  margin: 0px 0px 0px 0px !important;
  padding: 0.2em;
  width: 100%;
  margin-left: 0.5em !important;
}
.name {
  text-align: left;
  font-weight: bold;
  font-size: 1em;
  width: 75%;
  align-self: flex-end;
}
.description {
  justify-content: left;
  text-align: left;
  width: 65%;
  display: inline-block;
}
.price-container {
  display: inline-flex;
  width: 100%;
  padding: 0em !important;
}
.price-content {
  text-align: end;
  width: 25%;
}
.price {
  color: #0D6496 !important;
}
h1,
h2 {
  font-weight: normal;
}
p {
  font-weight: lighter;
  font-size: 0.8em;
  margin: 0em !important;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #0D6496 !important;
}

.bwo-title-inline {
  display: inline;
}

.bwo-menu-row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.item-content {
  margin: 20px 0px 20px 0px;
}
</style>



// WEBPACK FOOTER //
// src/Components/AdditionalItemBandAid.vue